import React, {memo} from 'react'
import cx from 'classnames'
import {find} from 'lodash'

import { formatPrice } from '../../../../../../../modules/product/productDesktopUtils'
import HbPlaceholderFrame from '../../../../../../../components/Placeholder/frame/HbPlaceholderFrame'
import HbImageView from '../../../../../../../components/HbImage/view/HbImageView'

/* Styles */
import s from './options.scss'

const OptionItem = memo(({
  option,
  onSelectChange,
  isSelected = false,
  isDisabled,
  unAvailableVariants,
  activeVariant
}) => {
  const handleClick = () => {
    onSelectChange(option?.value)
  }

  const isUnAvailableVariant = find(unAvailableVariants, {
    ...activeVariant?.values,
    [option?.extraProps?.name]: option?.extraProps?.value,
  })

  return (
    <button
      id={option?.value}
      role='menuitem'
      className={cx(s.root, {[s.selected]: isSelected}, {[s.disabled]: isDisabled || isUnAvailableVariant})}
      onClick={handleClick}
      data-test-id={'option-item'}>
        <div className={s.nameContainer}>
          {option?.extraProps?.thumbnail?.notFormattedUrl &&
            <HbPlaceholderFrame>
              <HbImageView
                className={s.image}
                image={{
                  src: option?.extraProps?.thumbnail?.notFormattedUrl?.replace?.('{size}', '32-32'),
                  size: `32-32`,
                  componentSize: {
                    width: 32,
                    height: 32,
                  },
                }}/>
            </HbPlaceholderFrame>
          }
          {option?.label}
        </div>
        {option?.extraProps?.price &&
          <div className={s.price}>
            {formatPrice(option?.extraProps?.price)}
          </div>
        }
    </button>
  )
})

export default OptionItem
